import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const SmallLaboratoryTubeIcon = createIcon({
  displayName: 'SmallLaboratoryTubeIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <line x1="20.5" x2="13.77" y1="10.23" y2="3.5"></line>
        <path d="M19.379 9.106l-10.465 10.465 8.31612e-08-8.32333e-08c-1.23743 1.2385-3.24456 1.23937-4.48306.00194359 -.00064809-.000647529-.0012959-.00129534-.00194343-.00194343v0l-1.48453e-07-1.48324e-07c-1.2385-1.23743-1.23937-3.24456-.00194313-4.48306 .000647529-.00064809.00129534-.0012959.00194343-.00194343l10.465-10.465"></path>
        <line x1="7.01" x2="15.98" y1="12.5" y2="12.5"></line>
      </g>
      <path fill="none" d="M0 0h24v24h-24Z"></path>
    </>
  ),
})

const SmallLaboratoryTube: FC<IconProps> = (props) => {
  return <CustomIcon as={SmallLaboratoryTubeIcon} {...props} />
}

export default memo(SmallLaboratoryTube)
